import {asapScheduler, from, merge, Observable, of} from 'rxjs';
import {debounceTime, distinctUntilChanged, pluck, shareReplay, startWith, switchMap} from 'rxjs/operators';
import {translationsApi} from '@/api/TranslationsApi';
import {Route} from 'vue-router';

export function observeProp<T>(component: any, name: string) {
  return merge(
    of(component[name]),
    component.$watchAsObservable(name).pipe(pluck('newValue')),
  ).pipe(shareReplay(1)) as Observable<T>;
}

export function observeFieldAsUIInput(component: any, name: string) {
  return component.$watchAsObservable(name).pipe(
    pluck('newValue'),
    debounceTime(100),
    distinctUntilChanged(),
  ).pipe(startWith('')) as Observable<string>;
}

export function watchAsLoadedObservable(component: any, name: string) {
  return component.$watchAsObservable(name).pipe(
    pluck('newValue'),
    switchMap(() => of(true)),
    startWith(false),
  ) as Observable<boolean>;
}

export function observeRouteParam<T>($route$: Observable<Route>, name: string, defaultValue?: string) {
  return merge(
    of(defaultValue),
    $route$.pipe(switchMap((x: any) => of(x.params[name]))),
  ).pipe(shareReplay(1)) as Observable<T>;
}

export function generateLangSubscriptions(lang$: Observable<string>) {
  return {
    currentLang: lang$,
    translate: lang$.pipe(
      switchMap((lang: any) => from(translationsApi.getTranslations(lang), asapScheduler)),
      shareReplay(1),
    ),
  };
}
